<template>
  <div class="heade">
    <div class="heade-brand">
      <img v-if="state.backendLogoUrl" :src="state.backendLogoUrl" class="brand-logo" alt="logo" />
      <span class="brand-title">{{ state.backendSystemName || defaultBrandTitle }}</span>
      <span v-if="state.backendBrandRemark" class="brand-remark">{{ state.backendBrandRemark }}</span>
    </div>
    <div class="flex a-l-c user_r">
      <!-- <span class="text_dow">
        <el-icon color="#00357f"> <Warning /> </el-icon>版本信息</span
      >
      <span class="text_r" @click="operate()">
        <el-icon color="#00357f"> <Warning /> </el-icon>软件操作手册</span
      > -->
      <!-- <span class="conle">|</span> -->
      <Dropdown :user="state.user" />
      <!-- <div class="setting_user">123</div> -->
    </div>
  </div>
</template>

<script setup>
import { User, Lock, Warning } from "@element-plus/icons-vue";
import { onMounted, onUnmounted, ref, defineProps, reactive, defineEmits } from "vue";
import Dropdown from "./dropdown.vue"
import { getFormApi } from "@/api/system/setting";
import { DEFAULT_THEME, DEFAULT_BRAND_NAME, PLATFORM_ADMIN_REMARK, getBackendThemeColor, applyBackendBranding, getAdminHeaderBrand } from "@/utils/tenantBranding";
import { getLoginUser } from "@/utils/loginUser";
import { isPlatformAdminSession } from "@/utils/authSession";
const emit = defineEmits(["tips"]);
const circleUrl = ref();
const defaultBrandTitle = `${DEFAULT_BRAND_NAME} · 工程机械智慧管理平台`

const state = reactive({
  user: {},
  backendSystemName: "",
  backendLogoUrl: "",
  backendThemeColor: DEFAULT_THEME,
  backendBrandRemark: ""
})

const applyBrandState = (detail = {}) => {
  if (detail.backendSystemName != null) {
    state.backendSystemName = detail.backendSystemName
  }
  if (detail.backendLogoUrl != null) {
    state.backendLogoUrl = detail.backendLogoUrl
  }
  if (detail.backendThemeColor != null) {
    state.backendThemeColor = detail.backendThemeColor
  }
  if (detail.backendBrandRemark != null) {
    state.backendBrandRemark = detail.backendBrandRemark
  }
}

const onHeaderBrandChange = (e) => {
  applyBrandState(e?.detail || {})
}

onMounted(() => {
  try {
    state.user = getLoginUser()
    const isPlatformAdmin = isPlatformAdminSession()
    if (isPlatformAdmin) {
      applyBrandState({
        backendSystemName: DEFAULT_BRAND_NAME,
        backendBrandRemark: PLATFORM_ADMIN_REMARK,
        backendThemeColor: getBackendThemeColor(),
      })
    } else {
      applyBrandState({
        ...getAdminHeaderBrand(),
        backendThemeColor: getBackendThemeColor(),
      })
      getFormApi('{}').then((res) => {
        const data = res?.data || {}
        applyBackendBranding({
          backendSystemName: data.backendSystemName || "",
          backendLogoUrl: data.backendLogoUrl || "",
          backendThemeColor: data.backendThemeColor || DEFAULT_THEME,
          backendBrandRemark: data.backendBrandRemark || "",
        })
        applyBrandState({
          ...getAdminHeaderBrand(),
          backendThemeColor: getBackendThemeColor(),
        })
      }).catch(() => {})
    }
    window.addEventListener("backend-header-brand-change", onHeaderBrandChange)
  } catch (error) {

  }
})

onUnmounted(() => {
  window.removeEventListener("backend-header-brand-change", onHeaderBrandChange)
})

const operate = () => {
  window.open("https://docs.qq.com/slide/DRGp1T05jdVJ4Rm5t?xapp-target=blank");
};
</script>

<style lang="less" scoped>
.user {
  cursor: pointer;
}

.user_r {
  position: relative;
}

.setting_user {
  position: absolute;
  right: 0;
  top: 40px;
  width: 80px;
  height: 80px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: #fff;
}

/deep/.el-icon {
  font-size: 14px !important;
  margin-right: 5px;
  margin-top: 2px;
}

.heade {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--tenant-admin-header-bg, var(--admin-header-bg, #ffffff));
  border-bottom: 1px solid var(--admin-header-border, #e8eaed);
  height: 100%;
  padding: 0 20px;
  font-size: 14px;
}
.heade-brand {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 10px;
  min-width: 0;
}
.brand-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}
.brand-title {
  font-size: 16px;
  line-height: 20px;
  color: #303133;
}
.brand-remark {
  font-size: 12px;
  line-height: 20px;
  color: #666;
}

.text_dow {
  margin-right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.text_r {
  cursor: pointer;
  color: #00357f;
  display: flex;
  align-items: center;
}

.tips {
  width: 15px;
  margin-right: 10px;
  cursor: pointer;
}

.conle {
  font-size: 12px;
  margin: 0 30px;
  color: #636364;
  margin-top: -3px;
}

.title {
  font-size: 14px;
  color: #333;
  margin-right: 10px;
}

.txt_tips {
  cursor: pointer;
  color: #4e84f2;
}

.user_name {
  margin-right: 10px;
  color: #333333;
}
</style>
